import { contactWrite, type ContactEmail, type ContactPhone } from '@/app/(main)/client-detail/utils/contacts';
import type { CreateClientFormData, RelationshipType } from '@/types/clientsApiTypes';
import type { Nullable } from '@/types/common';
import { formatMMDDYYYYToYYYYMMDD } from '@/utils/formatDate';
import type { PayloadWithIsImageDeleted } from '../../../sections/types';

type RelatedBasicInfoFields = {
  client_id: number;
  userHasCertifiedTheInformation: boolean;
  preferred_name: string | null;
  relationship: CreateClientFormData['related_passengers'][number]['client']['relationship'];
  first_name?: string;
  middle_name: string | null;
  last_name?: string;
  gender?: Nullable<string>;
  email?: Nullable<string>;
  additional_emails: CreateClientFormData['related_passengers'][number]['client']['additional_emails'];
  phones: CreateClientFormData['related_passengers'][number]['client']['phones'];
  date_of_birth?: Nullable<string>;
  phone?: Nullable<string>;
  contact_primary_client_id?: Nullable<number>;
  preferred_airport_ids: number[];
  profile_picture_gallery_id?: number | null;
  crm_emails?: ContactEmail[] | null;
  crm_phones?: ContactPhone[] | null;
};

export const getRelatedBasicInfoPayload = (values: RelatedBasicInfoFields): PayloadWithIsImageDeleted['client'] => {
  return {
    id: values.client_id,
    relationship: values.relationship as RelationshipType | null,
    userHasCertifiedTheInformation: values.userHasCertifiedTheInformation,
    preferred_name: values.preferred_name,
    profile_picture_gallery_id: values.profile_picture_gallery_id,
    first_name: values.first_name ?? null,
    middle_name: values.middle_name,
    last_name: values.last_name ?? null,
    gender: values.gender ?? null,
    date_of_birth: values.date_of_birth ? formatMMDDYYYYToYYYYMMDD(values.date_of_birth) : null,
    contact_primary_client_id: values.contact_primary_client_id ?? null,
    preferred_airport_ids: values.preferred_airport_ids,
    ...contactWrite(values, values.crm_emails, values.crm_phones),
  };
};
